<main id="page-not-found">
  <div class="container">
    <div class="row flex items-center justify-center h-screen">
      <div class="col-12 text-center">
        <p class="error-type">{{ 'PAGE_NOT_FOUND.ERROR_TYPE' | translate }}</p>
        <h1 class="mt-4">{{ 'PAGE_NOT_FOUND.TITLE' | translate }}</h1>
        <p class="mt-6">{{ 'PAGE_NOT_FOUND.DESCRIPTION' | translate }}</p>
        <div class="flex items-center justify-center btn-wr">
          <button id="btn-back-home" class="btn primary-btn" pButton (click)="backToMainPage()">
            {{ 'PAGE_NOT_FOUND.BTN_BACK_HOME' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
